module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#222222"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.$_view_quesDetail
    },
    slot: "right"
  }, [_vm._v("问卷明细")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one",
    style: (_vm.imgStyle)
  }, [_c('span', [_vm._v(_vm._s(_vm.params.result))])]), _vm._v(" "), _c('p', {
    staticClass: "com-again-test",
    on: {
      "click": _vm.$_evaluation_again
    }
  }, [_vm._v("\n            重新测评\n          ")]), _vm._v(" "), (_vm.params.isLowAccept == 0) ? _c('p', {
    staticClass: "res-two"
  }, [_vm._v("\n            您适合购买的产品风险等级为"), _c('span', [_vm._v(_vm._s(_vm.level))]), _vm._v("的基金\n          ")]) : _vm._e(), _vm._v(" "), (_vm.params.isLowAccept == 1) ? _c('p', {
    staticClass: "res-two"
  }, [_c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("风险承受最低类别")]), _vm._v("，您不可购买风险等级高于"), _c('span', [_vm._v("R1")]), _vm._v(" 的基金\n          ")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.params.specialObj) ? _c('table-list', {
    attrs: {
      "baseInfo": _vm.params
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('button', {
    staticClass: "com-btn-submit-radius weui-btn weui-btn_primary",
    on: {
      "click": _vm.$_evaluation_checkSubmit
    }
  }, [_vm._v("提 交")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('h4', [_vm._v("重要声明")]), _vm._v(" "), _c('p', [_vm._v("\n            您的风险承受能力评估结果是根据您填写的《风险测评问卷》以及其他相关信息综合评估得出，旨在协助您选择合适的产品或服务类别，并不能取代您自己的投资判断，也不会降低产品或服务的固有风险。建议您在产品购买过程中结合自身投资行为，并做出审慎的投资判断。\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7349b9de"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Evaluation/lastLowEnd.vue
// module id = 1070
// module chunks = 1